/* unplugin-vue-components disabled */import { render } from "./new-chat.vue?vue&type=template&id=b70f250a"
import script from "./new-chat.vue?vue&type=script&lang=js"
export * from "./new-chat.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/new-chat/new-chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b70f250a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b70f250a', __exports__)) {
    api.reload('b70f250a', __exports__)
  }
  
  module.hot.accept("./new-chat.vue?vue&type=template&id=b70f250a", () => {
    api.rerender('b70f250a', render)
  })

}


export default __exports__